// extracted by mini-css-extract-plugin
export default {"header":"FirstSignup_header__RQurQ","inputsContainer":"FirstSignup_inputsContainer__+D-A5","confirmButton":"FirstSignup_confirmButton__wZvr4","navLink":"FirstSignup_navLink__rD7pz"};